import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import axiosInstanceV2 from "@lhd/libs/axiosV2";
import { fetchSalaryWorkers } from "./salaryWorkers";

const fetchTransfers = async (year: any, companyId: any) => {
  return await axiosInstanceV2({
    method: "get",
    url: SERVICES.TRANSFER,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
    },
  }).then((res) => res.data || []);
};

const fetchCompanies = async () => {
  return await axios({
    method: "get",
    url: `${SERVICES.COMPANIES}/companies_for_company_bar`,
    params: {
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      scope: "list_all",
    },
  }).then((res) => res.data || []);
};

export const usePromiseSettledTransfers = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = {
    staleTime: 0,
    cacheTime: 0,
    // retry: 1,
    enabled: !!year,
  };

  return useQueries({
    queries: [
      {
        queryKey: ["QUERY_NAME.TRANSFERS", 1, year, companyId],
        queryFn: () => fetchTransfers(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.TRANSFERS", 2, year, companyId],
        queryFn: () => fetchSalaryWorkers(companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.TRANSFERS", 3, year, companyId],
        queryFn: () => fetchCompanies(),
        ...queryConfig,
      },
    ],
  });
};

export const useSubmitTransfers = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axiosInstanceV2({
        method: "post",
        url: SERVICES.TRANSFER_SAVE,
        data: payload,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.TRANSFERS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
